// Campus photo for /colleges/university-of-missouri: CC BY-SA 3.0, by Fresaj, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AJesse_Hall_and_The_Columns_on_the_Francis_Quadrangle.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-missouri/; credited under the photo.
const photo = {
    "slug": "university-of-missouri",
    "alt": "Jesse Hall and the Columns on the Francis Quadrangle at the University of Missouri in Columbia",
    "src": "/colleges/university-of-missouri/campus-1600.webp",
    "srcSmall": "/colleges/university-of-missouri/campus-800.webp",
    "srcMid": "/colleges/university-of-missouri/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-missouri/og.jpg",
    "title": "Jesse Hall and The Columns on the Francis Quadrangle",
    "author": "Fresaj",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AJesse_Hall_and_The_Columns_on_the_Francis_Quadrangle.jpg",
    "read": "2026-10-01"
};

export default photo;
